"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TakeoverFooter = void 0;
var react_1 = __importDefault(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var TakeoverSection_1 = require("./TakeoverSection");
var TakeoverFooter = function (_a) {
    var align = _a.align, children = _a.children, className = _a.className, props = __rest(_a, ["align", "children", "className"]);
    var TakeoverFooterClasses = classnames_1.default('TakeoverFooter', className, {
        'TakeoverFooter--left': align === 'left',
        'TakeoverFooter--center': align === 'center',
        'TakeoverFooter--right': align === 'right',
        'TakeoverFooter--space-between': align === 'space-between',
    });
    if (react_1.default.Children.count(children) === 0)
        return null;
    return (react_1.default.createElement(TakeoverSection_1.TakeoverSection, __assign({ className: TakeoverFooterClasses }, props), children));
};
exports.TakeoverFooter = TakeoverFooter;
exports.TakeoverFooter.defaultProps = {
    align: 'right',
};
//# sourceMappingURL=TakeoverFooter.js.map